/**
 * @flow
 * @relayHash a56410bb866a7259d3901bd634e4a37d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteVendorInput = {|
  id: string
|};
export type DeleteVendorMutationVariables = {|
  input: DeleteVendorInput
|};
export type DeleteVendorMutationResponse = {|
  +deleteVendor: {|
    +success: boolean
  |}
|};
export type DeleteVendorMutation = {|
  variables: DeleteVendorMutationVariables,
  response: DeleteVendorMutationResponse,
|};
*/


/*
mutation DeleteVendorMutation(
  $input: DeleteVendorInput!
) {
  deleteVendor(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteVendorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteVendor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteVendorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteVendorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteVendorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteVendorMutation",
    "id": null,
    "text": "mutation DeleteVendorMutation(\n  $input: DeleteVendorInput!\n) {\n  deleteVendor(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '75db03e1092a46d6305da3de3483b3f9';
module.exports = node;
